import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../components/default/header";
import Breadcrumb from "../../../default/breadcrumb/breadcrumb";
import StoreSidebarMenu from "../../menu/storeSidebarMenu";
import MyPlanData from "./myPlanData";
import { Link } from "react-router-dom";

const UserMyPlan = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>User billing info</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <StoreSidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Subscriptions</h3>
                        <>
                            <Link className="list-filter add-new-btn" to="/user/store/subscriptions">
                                <i className="ri-add-line"></i><span>Add New</span>
                            </Link>
                        </>
                    </div>
                    <MyPlanData />
                </div>
            </div>
        </div>

    );
}

export default UserMyPlan;